<div style="font-family: &quot;Helvetica&quot;; overflow: hidden">
  <canvas #canvas id="canvas" style="background: gray; width: 100%; height: 100%"></canvas>
</div>
